webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(148);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(147);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _App = __webpack_require__(127);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(118);
	__webpack_require__(21);
	__webpack_require__(116);
	__webpack_require__(57);
	__webpack_require__(117);
	
	_vue2.default.use(_vueResource2.default);
	
	new _vue2.default({
	  el: '#app',
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(20);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: {
	    isMobile: true,
	    modal: true,
	    map: false,
	    isEmbed: false
	  },
	  iconOptions: function iconOptions(options) {
	    var defaults = {
	      options: {
	        iconSize: [32, 37],
	        iconAnchor: [16, 35]
	      }
	    };
	    var DefIcon = L.Icon.extend(_lodash2.default.merge(defaults, options));
	    return new DefIcon();
	  },
	
	  cache: {
	    render: '',
	    activate: true,
	    categories: [],
	    maps: [],
	    mapsChild: [],
	    category: [],
	    category_infos: [],
	    map: [],
	    mapUrl: [],
	    places: [],
	    search: {},
	    markersGroup: {}
	  }
	};

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  url: {
	    categories: cgy_vars.links.categories,
	    categoriesComplete: cgy_vars.links.categoriesComplete,
	    category: cgy_vars.links.category,
	    categoryInclude: cgy_vars.links.categoryInclude,
	    category_infos: cgy_vars.links.category_infos,
	    form: cgy_vars.links.form,
	    list: cgy_vars.links.list,
	    map: cgy_vars.links.map,
	    mapUrl: cgy_vars.links.mapUrl,
	    maps: cgy_vars.links.maps,
	    pages: cgy_vars.links.pages,
	    place: cgy_vars.links.place,
	    places: cgy_vars.links.places,
	    search: cgy_vars.links.search,
	    nonce: ''
	  }
	};

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var polyline = __webpack_require__(56);
	var directionsService = new google.maps.DirectionsService();
	L.Routing = L.Routing || {};
	L.Routing.Google = L.Class.extend({
	  options: {
	    travelMode: google.maps.TravelMode.DRIVING,
	    unitSystem: google.maps.UnitSystem.METRIC,
	    provideRouteAlternatives: true
	  },
	  initialize: function initialize(options) {
	    L.Util.setOptions(this, options);
	  },
	  _flatten: function _flatten(arrs) {
	    var arr = [],
	        i;
	    for (i = 0; i < arrs.length; i++) {
	      arr = arr.concat(arrs[i]);
	    }return arr;
	  },
	  _decodePolyline: function _decodePolyline(geometry) {
	    var coords = polyline.decode(geometry, 5),
	        latlngs = new Array(coords.length),
	        i;
	    for (i = 0; i < coords.length; i++) {
	      latlngs[i] = new L.LatLng(coords[i][0], coords[i][1]);
	    }
	
	    return latlngs;
	  },
	  route: function route(waypoints, callback, context, options) {
	    var that = this;
	    var directions = this.options;
	    directions.origin = waypoints[0].latLng.lat + ',' + waypoints[0].latLng.lng;
	    directions.destination = waypoints[waypoints.length - 1].latLng.lat + ',' + waypoints[waypoints.length - 1].latLng.lng;
	    if (waypoints.length > 2) {
	      directions.waypoints = waypoints.slice(1, waypoints.length - 1).map(function (waypoint) {
	        return {
	          location: waypoint.latLng.lat + ',' + waypoint.latLng.lng,
	          stopover: false
	        };
	      });
	    }
	
	    directionsService.route(directions, function (result, status) {
	      if (status == google.maps.DirectionsStatus.OK) {
	        callback.call(context || callback, null, result.routes.map(function (route) {
	          var iroute = {},
	              i,
	              j,
	              step;
	          iroute.name = route.summary;
	          iroute.summary = {
	            totalDistance: that._flatten(route.legs.map(function (leg) {
	              return leg.steps.map(function (step) {
	                return step.distance.value;
	              });
	            })).reduce(function (previousValue, currentValue) {
	              return previousValue + currentValue;
	            }),
	            totalTime: that._flatten(route.legs.map(function (leg) {
	              return leg.steps.map(function (step) {
	                return step.duration.value;
	              });
	            })).reduce(function (previousValue, currentValue) {
	              return previousValue + currentValue;
	            })
	          };
	
	          iroute.coordinates = [];
	          var indices = [],
	              indicesSecondary = [];
	
	          for (i = 0; i < route.legs.length; i++) {
	            indicesSecondary = [];
	            for (j = 0; j < route.legs[i].steps.length; j++) {
	              indicesSecondary.push(iroute.coordinates.length);
	              step = route.legs[i].steps[j];
	              iroute.coordinates = iroute.coordinates.concat(that._decodePolyline(step.polyline.points));
	            }
	            indices.push(indicesSecondary);
	          }
	          iroute.inputWaypoints = waypoints || [];
	          iroute.waypoints = iroute.actualWaypoints = waypoints;
	          iroute.waypointIndices = [0, iroute.coordinates.length - 1];
	
	
	          iroute.instructions = [];
	          for (i = 0; i < route.legs.length; i++) {
	            for (j = 0; j < route.legs[i].steps.length; j++) {
	              step = route.legs[i].steps[j];
	              iroute.instructions.push({
	                type: 'Straight',
	                text: step.instructions.replace(/<(?:.|\n)*?>/gm, ''),
	                distance: step.distance.value,
	                time: step.duration.value,
	                index: indices[i][j],
	                exit: null });
	            }
	          }
	          return iroute;
	        }));
	      } else {
	        callback.call(context, {
	          status: status,
	          message: result
	        });
	      }
	    });
	    return this;
	  }
	});
	
	L.Routing.google = function (options) {
	  return new L.Routing.Google(options);
	};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(4);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Maps = __webpack_require__(129);
	
	var _Maps2 = _interopRequireDefault(_Maps);
	
	var _Modal = __webpack_require__(130);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Panel = __webpack_require__(131);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _PlaceInfo = __webpack_require__(132);
	
	var _PlaceInfo2 = _interopRequireDefault(_PlaceInfo);
	
	var _Proximity = __webpack_require__(133);
	
	var _Proximity2 = _interopRequireDefault(_Proximity);
	
	var _Range = __webpack_require__(134);
	
	var _Range2 = _interopRequireDefault(_Range);
	
	var _Route = __webpack_require__(135);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Contact = __webpack_require__(128);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  data: function data() {
	    return {
	      breakpoint: '1024px',
	      panel: '',
	      maps: '',
	      isEmbed: _store2.default.state.isEmbed
	    };
	  },
	
	  components: {
	    Maps: _Maps2.default, Panel: _Panel2.default, Modal: _Modal2.default, PlaceInfo: _PlaceInfo2.default, Proximity: _Proximity2.default, Range: _Range2.default, Route: _Route2.default, Contact: _Contact2.default
	  },
	  mounted: function mounted() {
	    for (var i = 0; i < this.$children.length; i++) {
	      if (this.$children[i].$options._componentTag === 'panel') {
	        this.panel = this.$children[i];
	      }
	    }
	    var mq = window.matchMedia('(max-width: ' + this.breakpoint + ')');
	    mq.addListener(this.checkisMobile);
	    this.checkisMobile(mq);
	    dataLayer.push({ rendu: 'Plan' });
	  },
	
	  methods: {
	    checkisMobile: function checkisMobile(mq) {
	      if (mq.matches) {
	        this.panel._data.panel = false;
	        _store2.default.state.isMobile = true;
	      } else {
	        this.panel._data.panel = true;
	        _store2.default.state.isMobile = false;
	      }
	    }
	  }
	};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsonUrl = __webpack_require__(6);
	
	var _jsonUrl2 = _interopRequireDefault(_jsonUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'contact',
	  data: function data() {
	    return {
	      modal: false,
	      email: '',
	      message: '',
	      nonce: cgy_vars.form.nonce,
	      placeId: '',
	      sent: false,
	      response: '',
	      error: false
	    };
	  },
	
	  methods: {
	    contactOnClick: function contactOnClick(place) {
	      this.modal = true;
	      if (place) {
	        this.placeId = place.id;
	        this.message = '\n\n---------------\nSupprimez ou changez le texte ci-dessous si votre remarque concerne un autre lieu ou sujet. \nLieu concern\xE9: ' + place.name;
	      }
	    },
	    sendMessage: function sendMessage() {
	      var _this = this;
	
	      var data = this.dataMessageInit();
	      this.$http.post(_jsonUrl2.default.url.form, data, { emulateJSON: true }).then(function (response) {
	        _this.sent = true;
	        _this.response = response.body.message;
	        dataLayer.push({ event: 'contact_webmaster_form_sent' });
	      }, function (response) {
	        _this.sent = true;
	        _this.error = true;
	        console.log('error', response);
	      });
	    },
	    dataMessageInit: function dataMessageInit() {
	      var nav = [];
	      var arr = ['userAgent', 'vendor', 'vendorSub', 'product', 'productSub', 'onLine', 'platform', 'language', 'cookieEnabled', 'doNotTrack', 'appCodeName', 'appName', 'appVersion'];
	      for (var i = 0; i < arr.length; i++) {
	        nav.push(arr[i] + ':' + navigator[arr[i]]);
	      }
	      var data = {
	        'mail': this.email,
	        'message': this.message,
	        'nonce': this.nonce,
	        'navigator': nav.join('\n'),
	        'location': this.placeId || ''
	      };
	      return data;
	    },
	    closeModal: function closeModal() {
	      this.sent = false;
	      this.modal = false;
	    }
	  }
	};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(69);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _store = __webpack_require__(4);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _jsonUrl = __webpack_require__(6);
	
	var _jsonUrl2 = _interopRequireDefault(_jsonUrl);
	
	var _lodash = __webpack_require__(20);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _leafletOmnivore = __webpack_require__(21);
	
	var _leafletOmnivore2 = _interopRequireDefault(_leafletOmnivore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'maps',
	  data: function data() {
	    return {
	      places: [],
	      info: '',
	      panel: '',
	      mapHeader: false,
	      mapLegend: false,
	      headerTitle: '',
	      headerDescription: '',
	      catInfos: [],
	      legends: [],
	      iconUrl: cgy_vars.defaultMarker,
	      showSidebar: cgy_vars.showSidebar || false,
	      mapRender: cgy_vars.map_style || false
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var lat = cgy_vars.map_center.split(',')[0];
	    var lng = cgy_vars.map_center.split(',')[1];
	    var zoom = cgy_vars.map_zoom;
	    _store2.default.state.map = L.map('map', { attributionControl: false }).setView([lat, lng], zoom);
	    this.defaultMapRender(this.mapRender);
	    _store2.default.state.map.zoomControl.setPosition('bottomright');
	
	    if (cgy_vars.cluster.cluster) {
	      _store2.default.cache.markersGroup = L.markerClusterGroup({
	        disableClusteringAtZoom: cgy_vars.cluster.cluster_zoom,
	        maxClusterRadius: cgy_vars.cluster.cluster_size
	      });
	    } else {
	      _store2.default.cache.markersGroup = L.featureGroup();
	    }
	
	    for (var i = 0; i < this.$parent.$children.length; i++) {
	      if (this.$parent.$children[i].$options.name === 'place-info') {
	        this.info = this.$parent.$children[i];
	      }
	      if (this.$parent.$children[i].$options.name === 'panel') {
	        this.panel = this.$parent.$children[i];
	      }
	    }
	
	    this.getDefaultCats().then(function (places) {
	      places.forEach(function (place) {
	        this.places.push(place);
	      }, _this);
	    }).then(function (_) {
	      _this.createDefaultPlacesMarker();
	    });
	
	    this.trimParams();
	  },
	
	  methods: {
	    getDefaultCats: function getDefaultCats() {
	      var _this2 = this;
	
	      var promises = [];
	
	      if (!_lodash2.default.isEmpty(cgy_vars.default_cats)) {
	        promises = cgy_vars.default_cats.map(function (cat) {
	          return _this2.$http.get(_jsonUrl2.default.url.category + '&id=' + cat);
	        });
	      }
	      promises.push(this.$http.get(_jsonUrl2.default.url.list));
	
	      return _promise2.default.all(promises).then(function (responses) {
	        return responses.map(function (response) {
	          return response.data.filter(function (item) {
	            return item.display === true;
	          });
	        });
	      }).then(function (cats) {
	        return cats.reduce(function (final, current) {
	          final = [].concat((0, _toConsumableArray3.default)(final), (0, _toConsumableArray3.default)(current));
	          return final;
	        }, []);
	      });
	    },
	    defaultMapRender: function defaultMapRender(type) {
	      if (_store2.default.cache.render) {
	        _store2.default.state.map.removeLayer(_store2.default.cache.render);
	      }
	
	      if (type === 'plan') {
	        dataLayer.push({ rendu: 'Plan' });
	        _store2.default.cache.render = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
	          subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
	        });
	      } else if (type === 'satellite') {
	        dataLayer.push({ rendu: 'Satellite' });
	        _store2.default.cache.render = L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
	          subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
	        });
	      } else if (type === 'relief') {
	        dataLayer.push({ rendu: 'Relief' });
	        _store2.default.cache.render = L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
	          subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
	        });
	      } else if (type === 'mixte') {
	        dataLayer.push({ rendu: 'Mixte' });
	        _store2.default.cache.render = L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
	          subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
	        });
	      } else {
	        return false;
	      }
	      _store2.default.state.map.addLayer(_store2.default.cache.render);
	    },
	    createDefaultPlacesMarker: function createDefaultPlacesMarker() {
	      this.places.forEach(function (place) {
	        var markerIcon = void 0;
	        if (place.icon) {
	          markerIcon = _store2.default.iconOptions({
	            options: {
	              iconUrl: place.icon
	            }
	          });
	        } else {
	          markerIcon = L.icon({
	            iconUrl: this.iconUrl,
	            iconSize: [21, 26],
	            iconAnchor: [10.5, 26]
	          });
	        }
	
	        var marker = L.marker([place.lat, place.lng], { icon: markerIcon, placeId: place.id }).on('click', this.info.markerOnClick);
	        this.markerPopup(marker, place.name);
	        marker.placeId = place.id;
	        _store2.default.cache.markersGroup.addLayer(marker);
	      }, this);
	      _store2.default.state.map.addLayer(_store2.default.cache.markersGroup);
	    },
	    markerPopup: function markerPopup(marker, name) {
	      marker.bindPopup(name, { offset: new L.Point(0, -28) });
	      marker.on('mouseover', function (e) {
	        this.openPopup();
	      });
	      marker.on('mouseout', function (e) {
	        this.closePopup();
	      });
	    },
	    trimParams: function trimParams() {
	      var params = void 0;
	      var type = void 0;
	      var id = void 0;
	      if (window.location.search) {
	        params = window.location.search.substring(1);
	        params = params.split('&')[0];
	        type = params.split('=')[0];
	        id = params.split('=')[1];
	      } else if (window.location.hash) {
	        params = window.location.hash.substring(1);
	        type = params.split('-')[0];
	        id = params.split('-')[1];
	      } else {
	        return false;
	      }
	      this.directLinkReq(type, id);
	      _store2.default.state.isEmbed = true;
	      this.handleEmbedTask();
	    },
	    handleEmbedTask: function handleEmbedTask() {
	      if (_store2.default.state.isEmbed) {
	        document.getElementById('app').classList.add('isEmbed');
	        if (this.showSidebar === '1') {
	          document.getElementById('app').classList.add('showSidebar');
	        }
	      }
	    },
	    directLinkReq: function directLinkReq(type, id) {
	      if (type === 'place') {
	        this.doPlaceReq(id);
	      } else if (type === 'map') {
	        this.mapHeader = true;
	        this.doMapReq(id);
	      } else if (type === 'cat') {
	        this.mapHeader = true;
	        this.doCatReq(id);
	      } else {
	        return false;
	      }
	    },
	    doPlaceReq: function doPlaceReq(id) {
	      var _this3 = this;
	
	      if (_store2.default.cache.places[id] && _store2.default.cache.activate) {
	        this.panel.displaySingleMarkerOnMap(id, _store2.default.cache.places[id].name, _store2.default.cache.places[id].icon, _store2.default.cache.places[id].lat, _store2.default.cache.places[id].lng);
	        this.injectSchemaScript(_store2.default.cache.places[id]);
	      } else {
	        this.$http.get(_jsonUrl2.default.url.place + '&id=' + id).then(function (response) {
	          _this3.panel.displaySingleMarkerOnMap(id, response.data.name, response.data.icon, response.data.lat, response.data.lng);
	          _this3.injectSchemaScript(response.data);
	          _store2.default.cache.places[id] = response.data;
	        }, function (response) {
	          console.log('error', response);
	        });
	      }
	    },
	    injectSchemaScript: function injectSchemaScript(place) {
	      this.$http.get('https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=' + place.lat + '&lon=' + place.lng).then(function (response) {
	        var div = document.createElement('script');
	        div.type = 'application/ld+json';
	        var jsonData = {
	          '@context': 'http://schema.org',
	          '@type': 'Place',
	          'address': {
	            '@type': 'PostalAddress',
	            'streetAddress': response.body.address.road,
	            'addressLocality': response.body.address.town,
	            'postalCode': response.body.address.postcode
	          },
	          'name': place.name
	        };
	        div.innerHTML = (0, _stringify2.default)(jsonData);
	        document.body.appendChild(div);
	      });
	    },
	    doCatReq: function doCatReq(id) {
	      var _this4 = this;
	
	      if (_store2.default.cache.category[id] && _store2.default.cache.activate) {
	        this.places = _store2.default.cache.category[id];
	        this.displayAllMarkerOnMap(this.places);
	      } else {
	        this.$http.get(_jsonUrl2.default.url.category + '&id=' + id).then(function (response) {
	          _this4.places = response.data;
	          _store2.default.cache.category[id] = response.data;
	          _this4.displayAllMarkerOnMap(_this4.places);
	        }, function (response) {
	          console.log('error', response);
	        });
	      }
	
	      if (_store2.default.cache.category_infos[id] && _store2.default.cache.activate) {
	        this.catInfos = _store2.default.cache.category_infos[id];
	        this.headerTitle = this.catInfos.name;
	        this.headerDescription = this.catInfos.description;
	      } else {
	        this.$http.get(_jsonUrl2.default.url.category_infos + '&id=' + id).then(function (response) {
	          _this4.catInfos = response.data;
	          _store2.default.cache.category_infos[id] = response.data;
	        }, function (response) {
	          console.log('error', response);
	        }).then(function (_) {
	          _this4.headerTitle = _this4.catInfos.name;
	          _this4.headerDescription = _this4.catInfos.description;
	        });
	      }
	    },
	    doMapReq: function doMapReq(id) {
	      var _this5 = this;
	
	      if (_store2.default.cache.map[id] && _store2.default.cache.activate) {
	        this.places = _store2.default.cache.map[id];
	        this.displayAllMarkerOnMap(this.places);
	      } else {
	        this.$http.get(_jsonUrl2.default.url.map + '&id=' + id).then(function (response) {
	          _store2.default.cache.map[id] = response.data;
	          _this5.places = _store2.default.cache.map[id];
	          _this5.displayAllMarkerOnMap(_this5.places);
	        }, function (response) {
	          console.log('error', response);
	        }).then(function (_) {
	          _this5.getMapInfo(id);
	        });
	      }
	    },
	    getMapInfo: function getMapInfo(id) {
	      var _this6 = this;
	
	      if (_store2.default.cache.mapUrl[id] && _store2.default.cache.activate) {
	        this.setupMapInfo(_store2.default.cache.mapUrl[id][0]);
	      } else {
	        this.$http.get(_jsonUrl2.default.url.mapUrl + '&id=' + id).then(function (response) {
	          _store2.default.cache.mapUrl[id] = response.data;
	          return _store2.default.cache;
	        }).then(function (cache) {
	          _this6.setupMapInfo(cache.mapUrl[id][0]);
	        }).catch(function (err) {
	          return console.log(err);
	        });
	      }
	    },
	    setupMapInfo: function setupMapInfo(map) {
	      this.headerTitle = map.name;
	      this.headerDescription = map.description;
	      if (map.url) {
	        this.displayKML(map);
	      }
	      if (map.legend) {
	        this.displayLegend(map);
	      }
	    },
	    displayKML: function displayKML(map) {
	      var customLayer = L.geoJson(null, {
	        style: function style(feature) {
	          return {
	            color: cgy_vars.line.strokeColor
	          };
	        }
	      }, this);
	      var layer = _leafletOmnivore2.default.kml(map.url, null, customLayer);
	      _store2.default.state.map.addLayer(layer);
	      layer.on('ready', function () {
	        _store2.default.state.map.fitBounds(layer.getBounds());
	      }, this);
	    },
	    displayLegend: function displayLegend(map) {
	      this.mapLegend = true;
	      _store2.default.cache.map[map.id].forEach(function (res) {
	        if (!_lodash2.default.find(this.legends, { name: res.name_cat })) {
	          var obj = {};
	          obj.name = res.name_cat;
	          obj.icon = res.placeIcon;
	          this.legends.push(obj);
	        }
	      }, this);
	    },
	    displayAllMarkerOnMap: function displayAllMarkerOnMap(places) {
	      _store2.default.cache.markersGroup.clearLayers();
	      if (places.length === 0) {
	        return;
	      }
	      for (var i = 0; i < places.length; i++) {
	        if (!this.checkIsValidPlace(places[i])) {
	          continue;
	        }
	
	        var markerIcon = void 0;
	        if (places[i].icon) {
	          markerIcon = _store2.default.iconOptions({
	            options: {
	              iconUrl: places[i].icon
	            }
	          });
	        } else {
	          markerIcon = L.icon({
	            iconUrl: this.iconUrl,
	            iconSize: [21, 26],
	            iconAnchor: [10.5, 26]
	          });
	        }
	
	        var marker = L.marker([places[i].lat, places[i].lng], { icon: markerIcon }).on('click', this.info.markerOnClick);
	        marker.placeId = places[i].id;
	        _store2.default.cache.markersGroup.addLayer(marker);
	      }
	      _store2.default.state.map.fitBounds(_store2.default.cache.markersGroup.getBounds());
	      _store2.default.state.map.addLayer(_store2.default.cache.markersGroup);
	    },
	    checkIsValidPlace: function checkIsValidPlace(place) {
	      return _lodash2.default.isNumber(+place.lat) && _lodash2.default.isNumber(+place.lng) && !_lodash2.default.isNaN(+place.lat) && !_lodash2.default.isNaN(+place.lng) && place.lat && place.lng;
	    },
	    proximityClick: function proximityClick() {
	      this.panel.proximityClick();
	    }
	  }
	};

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'modal',
	  data: function data() {
	    return {
	      modal: true,
	      modalCookie: false,
	      display: cgy_vars.popup.display_popup,
	      title: cgy_vars.popup.title,
	      text: cgy_vars.popup.text,
	      button: cgy_vars.popup.button
	    };
	  },
	  mounted: function mounted() {
	    this.checkCookie();
	  },
	
	  methods: {
	    closeModal: function closeModal() {
	      this.modal = false;
	      for (var i = 0; i < this.$parent.$children.length; i++) {
	        if (this.$parent.$children[i].$options.name === 'panel') {
	          this.$parent.$children[i].openPanel();
	        }
	      }
	    },
	
	    setCookie: function setCookie(cname, exdays) {
	      var d = new Date();
	      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	      var expires = 'expires=' + d.toUTCString();
	      document.cookie = cname + '=' + d + ';' + expires + ';path=/';
	    },
	
	    getCookie: function getCookie(cname) {
	      var name = cname + '=';
	      var ca = document.cookie.split(';');
	      for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) === ' ') {
	          c = c.substring(1);
	        }
	        if (c.indexOf(name) === 0) {
	          return c.substring(name.length, c.length);
	        }
	      }
	      return '';
	    },
	    checkCookie: function checkCookie() {
	      var modal = this.getCookie('modal');
	      if (modal !== '') {
	        this.modalCookie = true;
	      } else {
	        this.setCookie('modal', 1);
	      }
	    }
	  }
	};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _store = __webpack_require__(4);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _jsonUrl = __webpack_require__(6);
	
	var _jsonUrl2 = _interopRequireDefault(_jsonUrl);
	
	var _Search = __webpack_require__(136);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _lodash = __webpack_require__(20);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _leafletOmnivore = __webpack_require__(21);
	
	var _leafletOmnivore2 = _interopRequireDefault(_leafletOmnivore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'panel',
	  components: {
	    Search: _Search2.default
	  },
	  data: function data() {
	    return {
	      panel: false,
	      isLoading: false,
	      resultBtn: false,
	      mapResultBtn: false,
	      logo: cgy_vars.theme_mods.site_logo,
	      iconUrl: cgy_vars.defaultMarker,
	      slogan: cgy_vars.theme_mods.site_baseline,
	      pages: '',
	      level: 1,
	      levelHistory: 1,
	      levelName: '',
	      parentName: '',
	      history: [],
	      cats: [],
	      catsNb: 0,
	      maps: [],
	      mapsNb: 0,
	      parentMapName: '',
	      items: [],
	      marker: '',
	      kmlsArr: [],
	      kmlGroup: [],
	      mapsId: [],
	      keyword: '',
	      info: '',
	      proximity: '',
	      range: '',
	      route: '',
	      contact: '',
	      strokeColor: cgy_vars.line.strokeColor,
	      isEmbed: _store2.default.state.isEmbed
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.kmlGroup = new L.FeatureGroup();
	
	    this.$http.get(_jsonUrl2.default.url.categories).then(function (response) {
	      _this.cats = response.data;
	      _store2.default.cache.categories = _this.cats;
	      for (var _i = _this.cats.length - 1; _i >= 0; _i--) {
	        if (_this.cats[_i].count) {
	          _this.catsNb += _this.cats[_i].count;
	        }
	      }
	    });
	
	    this.$http.get(_jsonUrl2.default.url.maps).then(function (response) {
	      _this.maps = response.data;
	      _store2.default.cache.maps = _this.maps;
	      _this.mapsNb = _this.maps.length;
	    });
	
	    if (_store2.default.cache.pages) {
	      this.pages = _store2.default.cache.pages;
	    } else {
	      this.$http.get(_jsonUrl2.default.url.pages).then(function (response) {
	        _this.pages = response.data;
	        _store2.default.cache.pages = _this.pages;
	      });
	    }
	
	    for (var i = 0; i < this.$parent.$children.length; i++) {
	      if (this.$parent.$children[i].$options.name === 'place-info') {
	        this.info = this.$parent.$children[i];
	      }
	      if (this.$parent.$children[i].$options.name === 'proximity') {
	        this.proximity = this.$parent.$children[i];
	      }
	      if (this.$parent.$children[i].$options.name === 'range') {
	        this.range = this.$parent.$children[i];
	      }
	      if (this.$parent.$children[i].$options.name === 'route') {
	        this.route = this.$parent.$children[i];
	      }
	      if (this.$parent.$children[i].$options.name === 'contact') {
	        this.contact = this.$parent.$children[i];
	      }
	    }
	  },
	
	  watch: {
	    keyword: function keyword(val) {
	      this.items = _store2.default.cache.search[this.keyword];
	    }
	  },
	  methods: {
	    openPanel: function openPanel(name) {
	      if (!this.panel) {
	        if (_store2.default.state.isMobile) {
	          this.panel = true;
	        }
	        this.level = this.levelHistory;
	        this.handlePanelBodyClass(this.panel);
	        this.closeChildComponents();
	      } else {
	        this.level++;
	        this.levelHistory++;
	        this.levelName = name;
	      }
	    },
	
	    closePanel: function closePanel() {
	      if (_store2.default.state.isMobile) {
	        this.panel = false;
	      }
	      this.level = 1;
	      this.handlePanelBodyClass(this.panel);
	    },
	
	    closeChildPanel: function closeChildPanel() {
	      this.level--;
	      this.levelHistory--;
	      if (this.level > 2) {
	        var i = this.history.length - 2;
	        var id = this.history[i].id;
	        this.parentName = this.history[i].name;
	
	        this.history.pop();
	
	        if (this.levelName === 'place') {
	          this.doCategoryReq(id, this.displayResultBtn);
	        } else if (this.levelName === 'map') {
	          this.doMapChildReq(id, this.displayResultBtn);
	        }
	      } else {
	        if (this.levelName === 'map') {
	          this.doMapChildReq(null, this.displayResultBtn);
	        }
	
	        this.history = [];
	      }
	    },
	    closeChildComponents: function closeChildComponents() {
	      this.proximity.closeProximity();
	      this.info.closePlaceInfo();
	      this.route.closeRoute();
	      this.range.closeRange();
	    },
	
	    handlePanelBodyClass: function handlePanelBodyClass(state) {
	      var body = document.querySelectorAll('body')[0];
	      if (state) {
	        body.classList.add('panel-opened');
	      } else {
	        body.classList.remove('panel-opened');
	      }
	    },
	
	    goToFirstLevel: function goToFirstLevel() {
	      this.level = 1;
	      this.levelHistory = 1;
	      this.openPanel();
	    },
	
	    showItems: function showItems(name, id) {
	      this.level++;
	      this.levelHistory++;
	
	      this.buildPanelHistory(name, id);
	
	      this.parentName = name;
	
	      this.doCategoryReq(id, this.displayResultBtn);
	    },
	    showMaps: function showMaps(name, id) {
	      this.level++;
	      this.levelHistory++;
	
	      this.buildPanelHistory(name, id);
	
	      this.parentMapName = name;
	
	      this.doMapChildReq(id, this.displayMapResultBtn);
	    },
	
	    doCategoryReq: function doCategoryReq(id, callback) {
	      var _this2 = this;
	
	      if (_store2.default.cache.category[id] && _store2.default.cache.activate) {
	        this.items = _store2.default.cache.category[id];
	        if (callback !== null) {
	          callback();
	        }
	      } else {
	        this.isLoading = true;
	        this.$http.get(_jsonUrl2.default.url.category + '&id=' + id).then(function (response) {
	          _this2.items = response.data;
	          _store2.default.cache.category[id] = response.data;
	        }, function (response) {
	          console.log('error', response);
	        }).then(function (_) {
	          _this2.isLoading = false;
	          if (callback !== null) {
	            callback();
	          }
	        });
	      }
	    },
	    doMapChildReq: function doMapChildReq(id, callback) {
	      var _this3 = this;
	
	      if (id === null) {
	        this.maps = _store2.default.cache.maps;
	      } else {
	        if (_store2.default.cache.mapsChild[id] && _store2.default.cache.activate) {
	          this.maps = _store2.default.cache.mapsChild[id];
	          if (callback !== null) {
	            callback();
	          }
	        } else {
	          this.isLoading = true;
	          this.$http.get(_jsonUrl2.default.url.maps + '&id=' + id).then(function (response) {
	            _this3.maps = response.data;
	            _store2.default.cache.mapsChild[id] = response.data;
	          }, function (response) {
	            console.log('error', response);
	          }).then(function (_) {
	            _this3.isLoading = false;
	            if (callback !== null) {
	              callback();
	            }
	          });
	        }
	      }
	    },
	
	    displayResultBtn: function displayResultBtn() {
	      for (var i = 0; i < this.items.length; i++) {
	        this.resultBtn = false;
	        if (this.items[i].type !== 'category') {
	          this.resultBtn = true;
	          this.displayAllMarkerOnMap(this.items);
	          return;
	        }
	      }
	    },
	    displayMapResultBtn: function displayMapResultBtn() {
	      for (var i = 0; i < this.maps.length; i++) {
	        this.mapResultBtn = false;
	        if (!this.maps[i].has_children) {
	          this.mapResultBtn = true;
	          this.displayMapsElements();
	          return;
	        }
	      }
	    },
	
	    buildPanelHistory: function buildPanelHistory(name, id) {
	      var parent = {};
	      parent.name = name;
	      parent.id = id;
	      this.history.push(parent);
	    },
	
	    getPlaceInfo: function getPlaceInfo(id) {
	      var _this4 = this;
	
	      if (_store2.default.cache.places[id] && _store2.default.cache.activate) {
	        this.displaySingleMarkerOnMap(id, _store2.default.cache.places[id].name, _store2.default.cache.places[id].icon, _store2.default.cache.places[id].lat, _store2.default.cache.places[id].lng);
	      } else {
	        this.$http.get(_jsonUrl2.default.url.place + '&id=' + id).then(function (response) {
	          _this4.displaySingleMarkerOnMap(id, response.data.name, response.data.icon, response.data.lat, response.data.lng);
	          _store2.default.cache.places[id] = response.data;
	        }, function (response) {
	          console.log('error', response);
	        });
	      }
	    },
	
	    displaySingleMarkerOnMap: function displaySingleMarkerOnMap(id, name, icon, lat, lng) {
	      _store2.default.cache.markersGroup.clearLayers();
	
	      this.marker = L.marker([lat, lng]).on('click', this.info.markerOnClick);
	      this.marker.placeId = id;
	      var markerIcon = void 0;
	      if (icon) {
	        markerIcon = _store2.default.iconOptions({
	          options: {
	            iconUrl: icon
	          }
	        });
	      } else {
	        markerIcon = L.icon({
	          iconUrl: this.iconUrl,
	          iconSize: [21, 26],
	          iconAnchor: [10.5, 26]
	        });
	      }
	      this.marker.setIcon(markerIcon);
	      _store2.default.cache.markersGroup.addLayer(this.marker);
	
	      this.centerMapOnMarker(this.marker);
	      this.markerPopup(this.marker, name);
	
	      if (_store2.default.state.isMobile) {
	        this.closePanel();
	      }
	
	      this.active = true;
	      this.expand = true;
	      this.info.getClickedMarkerData(id);
	    },
	    markerPopup: function markerPopup(marker, name) {
	      marker.bindPopup(name, { offset: new L.Point(0, -28) });
	      marker.on('mouseover', function (e) {
	        this.openPopup();
	      });
	      marker.on('mouseout', function (e) {
	        this.closePopup();
	      });
	    },
	
	    centerMapOnMarker: function centerMapOnMarker(marker) {
	      var latLngs = [marker.getLatLng()];
	      var markerBounds = L.latLngBounds(latLngs);
	      _store2.default.state.map.fitBounds(markerBounds);
	    },
	
	    displayAllMarkerOnMap: function displayAllMarkerOnMap(places) {
	      _store2.default.cache.markersGroup.clearLayers();
	      if (places.length === 0) {
	        return;
	      }
	      for (var i = 0; i < places.length; i++) {
	        if (!this.checkIsValidPlace(places[i])) {
	          continue;
	        }
	
	        var markerIcon = void 0;
	        if (places[i].icon) {
	          markerIcon = _store2.default.iconOptions({
	            options: {
	              iconUrl: places[i].icon
	            }
	          });
	        } else {
	          markerIcon = L.icon({
	            iconUrl: this.iconUrl,
	            iconSize: [21, 26],
	            iconAnchor: [10.5, 26]
	          });
	        }
	
	        var marker = L.marker([places[i].lat, places[i].lng], { icon: markerIcon }).on('click', this.info.markerOnClick);
	        this.markerPopup(marker, places[i].name);
	        marker.placeId = places[i].id;
	        _store2.default.cache.markersGroup.addLayer(marker);
	      }
	      _store2.default.state.map.fitBounds(_store2.default.cache.markersGroup.getBounds());
	      _store2.default.state.map.addLayer(_store2.default.cache.markersGroup);
	      if (this.levelName !== 'map' && _store2.default.state.isMobile) {
	        this.closePanel();
	      }
	    },
	    checkIsValidPlace: function checkIsValidPlace(place) {
	      return _lodash2.default.isNumber(+place.lat) && _lodash2.default.isNumber(+place.lng) && !_lodash2.default.isNaN(+place.lat) && !_lodash2.default.isNaN(+place.lng) && place.lat && place.lng;
	    },
	
	    displayMapsElements: function displayMapsElements() {
	      var _this5 = this;
	
	      if (this.mapsId.length === 0) {
	        this.displayAllMarkerOnMap([]);
	        this.cleanKMLUnchecked();
	        return;
	      }
	      var reqs = [];
	      for (var i = this.mapsId.length - 1; i >= 0; i--) {
	        reqs.push(this.doMapsReq(this.mapsId[i]));
	      }
	      _promise2.default.all(reqs).then(function (data) {
	        var maps = [];
	        data.forEach(function (req) {
	          req.forEach(function (el) {
	            maps.push(el);
	          });
	        });
	        return maps;
	      }).then(function (maps) {
	        _this5.displayAllMarkerOnMap(maps);
	        _this5.displayKMLOnMap();
	      });
	    },
	    displayKMLOnMap: function displayKMLOnMap() {
	      this.cleanKMLUnchecked();
	      var that = this;
	      var i = this.mapsId.length - 1;
	      var id = this.mapsId[i];
	
	      var allMaps = _store2.default.cache.maps;
	      _store2.default.cache.mapsChild.forEach(function (item) {
	        allMaps = [].concat((0, _toConsumableArray3.default)(allMaps), (0, _toConsumableArray3.default)(item));
	      });
	      if (!_lodash2.default.find(this.kmlGroup, { id: id })) {
	        var map = _lodash2.default.find(allMaps, { id: id });
	        if (map.url) {
	          var kml = {};
	          kml.id = map.id;
	          var customLayer = L.geoJson(null, {
	            style: function style(feature) {
	              return {
	                color: that.strokeColor
	              };
	            }
	          }, this);
	          var layer = _leafletOmnivore2.default.kml(map.url, null, customLayer);
	          layer.mapId = map.id;
	          this.kmlGroup.addLayer(layer);
	          kml.layer = layer;
	          this.kmlsArr.push(kml);
	          _store2.default.state.map.addLayer(layer);
	          layer.on('ready', function () {
	            _store2.default.state.map.fitBounds(this.kmlGroup.getBounds());
	          }, this);
	        }
	      }
	    },
	    cleanKMLUnchecked: function cleanKMLUnchecked() {
	      var ids = [];
	      this.kmlsArr.forEach(function (kml) {
	        ids.push(kml.id);
	      });
	      var diffs = _lodash2.default.difference(ids, this.mapsId);
	      diffs.forEach(function (diff) {
	        var kml = _lodash2.default.find(this.kmlsArr, { id: diff });
	        var index = _lodash2.default.findIndex(this.kmlsArr, { id: diff });
	        _store2.default.state.map.removeLayer(kml.layer);
	        this.kmlsArr.splice(index, 1);
	      }, this);
	    },
	    doMapsReq: function doMapsReq(id) {
	      var _this6 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        if (_store2.default.cache.map[id] && _store2.default.cache.activate) {
	          resolve(_store2.default.cache.map[id]);
	        } else {
	          _this6.$http.get(_jsonUrl2.default.url.map + '&id=' + id).then(function (response) {
	            _store2.default.cache.map[id] = response.data;
	            resolve(response.data);
	          }, function (response) {
	            reject(response);
	          });
	        }
	      });
	    },
	    changeMapRender: function changeMapRender(type) {
	      _store2.default.state.map.removeLayer(_store2.default.cache.render);
	      if (type === 'plan') {
	        dataLayer.push({ rendu: 'Plan' });
	        _store2.default.cache.render = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
	          subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
	        });
	      } else if (type === 'sat') {
	        dataLayer.push({ rendu: 'Satellite' });
	        _store2.default.cache.render = L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
	          subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
	        });
	      } else if (type === 'relief') {
	        dataLayer.push({ rendu: 'Relief' });
	        _store2.default.cache.render = L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
	          subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
	        });
	      } else if (type === 'mixte') {
	        dataLayer.push({ rendu: 'Mixte' });
	        _store2.default.cache.render = L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
	          subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
	        });
	      } else {
	        return false;
	      }
	      _store2.default.state.map.addLayer(_store2.default.cache.render);
	    },
	    proximityClick: function proximityClick() {
	      var mapCenter = _store2.default.state.map.getCenter();
	      this.closePanel();
	      this.proximity.proximityOnClick(mapCenter);
	    },
	    rangeClick: function rangeClick() {
	      this.closePanel();
	      this.range.rangeOnClick();
	    },
	    routeClick: function routeClick() {
	      this.closePanel();
	      this.route.routeOnClick(null);
	    }
	  }
	};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(70);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _store = __webpack_require__(4);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _jsonUrl = __webpack_require__(6);
	
	var _jsonUrl2 = _interopRequireDefault(_jsonUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'place-info',
	  data: function data() {
	    return {
	      active: false,
	      expand: false,
	      iconUrl: cgy_vars.defaultMarker,
	      place: '',
	      markers: [],
	      proximity: '',
	      route: '',
	      contact: ''
	    };
	  },
	  mounted: function mounted() {
	    for (var i = 0; i < this.$parent.$children.length; i++) {
	      if (this.$parent.$children[i].$options.name === 'proximity') {
	        this.proximity = this.$parent.$children[i];
	      }
	      if (this.$parent.$children[i].$options.name === 'route') {
	        this.route = this.$parent.$children[i];
	      }
	      if (this.$parent.$children[i].$options.name === 'contact') {
	        this.contact = this.$parent.$children[i];
	      }
	    }
	  },
	
	  methods: {
	    markerOnClick: function markerOnClick(e) {
	      var id = e.target.placeId;
	
	      if (this.proximity.circle !== '') {
	        this.proximity.closeProximity(id);
	      }
	      this.getAllMarkers();
	
	      _store2.default.state.map.setView(e.latlng, 14);
	
	      if (this.markers.length > 1) {
	        this.handleMarkerOpacity(id);
	      }
	      this.getClickedMarkerData(id);
	    },
	    getClickedMarkerData: function getClickedMarkerData(id) {
	      var _this = this;
	
	      this.active = true;
	      this.expand = true;
	      if (_store2.default.cache.places[id] && _store2.default.cache.activate) {
	        this.place = _store2.default.cache.places[id];
	      } else {
	        this.$http.get(_jsonUrl2.default.url.place + '&id=' + id).then(function (response) {
	          _this.place = response.data;
	          _store2.default.cache.places[id] = response.id;
	        }, function (response) {
	          console.log('error', response);
	        });
	      }
	    },
	    getAllMarkers: function getAllMarkers() {
	      var layers = _store2.default.state.map._layers;
	      var that = this;
	      (0, _keys2.default)(layers).forEach(function (key) {
	        if (layers[key].placeId) {
	          that.markers.push(layers[key]);
	        }
	      });
	    },
	    handleMarkerOpacity: function handleMarkerOpacity(id) {
	      if (id) {
	        for (var i = 0; i < this.markers.length; i++) {
	          if (this.markers[i].placeId !== id) {
	            this.markers[i].setOpacity(0.5);
	          } else {
	            this.markers[i].setOpacity(1);
	          }
	        }
	      } else {
	        for (var _i = 0; _i < this.markers.length; _i++) {
	          this.markers[_i].setOpacity(1);
	        }
	      }
	    },
	    closePlaceInfo: function closePlaceInfo() {
	      this.active = false;
	      this.expand = false;
	      this.handleMarkerOpacity(null);
	    },
	    expandPlaceInfo: function expandPlaceInfo() {
	      this.expand = !this.expand;
	    },
	    proximityClick: function proximityClick() {
	      this.closePlaceInfo();
	      this.proximity.proximityOnClick(this.place);
	    },
	    routeClick: function routeClick() {
	      this.closePlaceInfo();
	      this.route.routeOnClick(this.place);
	    },
	    contactClick: function contactClick() {
	      this.closePlaceInfo();
	      this.contact.contactOnClick(this.place);
	    }
	  }
	};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(4);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _jsonUrl = __webpack_require__(6);
	
	var _jsonUrl2 = _interopRequireDefault(_jsonUrl);
	
	var _lodash = __webpack_require__(20);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'proximity',
	  data: function data() {
	    return {
	      active: false,
	      expand: false,
	      radius: cgy_vars.around.min / 1000,
	      rangeMin: cgy_vars.around.min / 1000,
	      rangeMax: cgy_vars.around.max / 1000,
	      iconUrl: cgy_vars.defaultMarker,
	      proxMarker: '',
	      categories: [],
	      circle: '',
	      strokeColor: cgy_vars.circle.strokeColor,
	      fillColor: cgy_vars.circle.fillColor,
	      selectedCat: [],
	      places: [],
	      markers: [],
	      info: ''
	    };
	  },
	
	  watch: {
	    radius: function radius(newRadius) {
	      this.circle.setRadius(newRadius * 1000 / 2);
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (_store2.default.cache.categories !== '') {
	      this.$http.get(_jsonUrl2.default.url.categories).then(function (response) {
	        _this.categories = response.data;
	        _store2.default.cache.categories = _this.categories;
	      });
	    } else {
	      this.categories = _store2.default.cache.categories;
	    }
	
	    this.$http.get(_jsonUrl2.default.url.places).then(function (response) {
	      _this.places = response.data;
	    });
	
	    for (var i = 0; i < this.$parent.$children.length; i++) {
	      if (this.$parent.$children[i].$options.name === 'place-info') {
	        this.info = i;
	      }
	    }
	  },
	
	  methods: {
	    proximityOnClick: function proximityOnClick(currentPlace) {
	      this.active = true;
	      this.expand = true;
	      this.radius = cgy_vars.around.min / 1000;
	      this.deleteAllMarkers();
	      this.addProximityMarker(currentPlace);
	      this.drawProximityCircle(currentPlace);
	    },
	    deleteAllMarkers: function deleteAllMarkers(id) {
	      this.markers = [];
	      _store2.default.cache.markersGroup.clearLayers();
	    },
	    addProximityMarker: function addProximityMarker(place) {
	      if (this.proxMarker && this.proxMarker !== '') {
	        _store2.default.state.map.removeLayer(this.proxMarker);
	      }
	      var markerIcon = L.icon({
	        iconUrl: this.iconUrl,
	        iconSize: [21, 26],
	        iconAnchor: [10.5, 26]
	      });
	      this.proxMarker = L.marker([place.lat, place.lng], { icon: markerIcon, draggable: true });
	      this.proxMarker.setZIndexOffset(1000);
	      _store2.default.state.map.addLayer(this.proxMarker);
	      this.addDraggableListener();
	    },
	    addDraggableListener: function addDraggableListener() {
	      var that = this;
	      this.proxMarker.on('drag', function (e) {
	        var marker = e.target;
	        var latlng = marker.getLatLng();
	        that.updateProximityCircle(latlng);
	      });
	    },
	    drawProximityCircle: function drawProximityCircle(place) {
	      if (this.circle && this.circle !== '') {
	        _store2.default.state.map.removeLayer(this.circle);
	      }
	      var lat = place.lat;
	      var lng = place.lng;
	      this.circle = L.circle([lat, lng], {
	        color: this.strokeColor,
	        fillColor: this.fillColor,
	        fillOpacity: 0.5,
	        radius: this.radius * 1000 / 2
	      }).addTo(_store2.default.state.map);
	      this.isInRange();
	    },
	    updateProximityCircle: function updateProximityCircle(latlng) {
	      this.circle.setLatLng(latlng);
	      this.isInRange();
	    },
	    getCats: function getCats() {
	      var _this2 = this;
	
	      var id = this.getSelectedCatsKey();
	      var req = '';
	      this.getSelectedCats().forEach(function (cat) {
	        req += '&terms[]=' + cat;
	      });
	      if (_store2.default.cache.places[id] && _store2.default.cache.activate) {
	        this.places = _store2.default.cache.places[id];
	        this.deleteAllMarkers();
	        this.isInRange();
	      } else {
	        this.$http.get(_jsonUrl2.default.url.places + '&' + req).then(function (response) {
	          _this2.places = response.data;
	          _store2.default.cache.places[id] = response.data;
	          _this2.deleteAllMarkers();
	          _this2.isInRange();
	        }, function (response) {
	          console.log('error', response);
	        });
	      }
	    },
	    getSelectedCats: function getSelectedCats() {
	      return this.selectedCat.sort();
	    },
	    getSelectedCatsKey: function getSelectedCatsKey() {
	      return this.getSelectedCats().join('-');
	    },
	    isInRange: function isInRange() {
	      var that = this;
	      this.places.forEach(function (place) {
	        if (place.lat && place.lng) {
	          var marker = L.marker([place.lat, place.lng]).on('click', that.$parent.$children[that.info].markerOnClick);
	          if (marker.getLatLng().distanceTo(that.circle.getLatLng()) <= that.circle.getRadius()) {
	            if (!_lodash2.default.find(that.markers, { id: place.id })) {
	              that.setupMarker(marker, place);
	              that.markers.push({ id: place.id, marker: marker });
	            }
	          } else {
	            if (_lodash2.default.find(that.markers, { id: place.id })) {
	              var toDel = _lodash2.default.find(that.markers, { id: place.id });
	              var arrIndex = that.markers.indexOf(toDel);
	              _store2.default.state.map.removeLayer(toDel.marker);
	              _store2.default.cache.markersGroup.removeLayer(toDel.marker);
	              that.markers.splice(arrIndex, 1);
	            }
	          }
	        }
	      });
	      _store2.default.state.map.addLayer(_store2.default.cache.markersGroup);
	    },
	    setupMarker: function setupMarker(marker, place) {
	      var markerIcon = _store2.default.iconOptions({
	        options: {
	          iconUrl: place.icon
	        }
	      });
	      marker.setIcon(markerIcon);
	      marker.placeId = place.id;
	      _store2.default.cache.markersGroup.addLayer(marker);
	    },
	    closeProximity: function closeProximity(id) {
	      this.active = false;
	      this.expand = false;
	      this.deleteAllMarkers(id);
	
	      _store2.default.state.map.removeLayer(this.proxMarker);
	      _store2.default.state.map.removeLayer(this.circle);
	    },
	    expandProximity: function expandProximity() {
	      this.expand = !this.expand;
	    }
	  }
	};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(4);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'range',
	  data: function data() {
	    return {
	      active: false,
	      expand: false,
	      range: 0,
	      iconUrl: cgy_vars.defaultMarker,
	      markers: [],
	      polylines: [],
	      strokeColor: cgy_vars.line.strokeColor
	    };
	  },
	
	  methods: {
	    rangeOnClick: function rangeOnClick() {
	      this.active = true;
	      this.expand = true;
	      this.addMarkerOnMapClick();
	    },
	    addMarkerOnMapClick: function addMarkerOnMapClick() {
	      var that = this;
	      if (this.active) {
	        _store2.default.state.map.on('click', function (e) {
	          var markerIcon = L.icon({
	            iconUrl: that.iconUrl,
	            iconSize: [21, 26],
	            iconAnchor: [10.5, 26]
	          });
	          var marker = L.marker(e.latlng, { icon: markerIcon });
	          _store2.default.state.map.addLayer(marker);
	          that.markers.push(marker);
	          that.drawLineBetweenMarkers();
	          that.distanceBetweenMarkers();
	        });
	      }
	    },
	    drawLineBetweenMarkers: function drawLineBetweenMarkers() {
	      if (this.markers.length < 2) {
	        return;
	      }
	      var latlngs = [];
	      var index = this.markers.length - 1;
	      var last = this.markers[index];
	      latlngs.push(last.getLatLng());
	      var prev = this.markers[index - 1];
	      latlngs.push(prev.getLatLng());
	      var polyline = L.polyline(latlngs, { color: this.strokeColor });
	      _store2.default.state.map.addLayer(polyline);
	      this.polylines.push(polyline);
	    },
	    distanceBetweenMarkers: function distanceBetweenMarkers() {
	      var that = this;
	      this.range = 0;
	      if (this.markers.length > 1) {
	        this.markers.forEach(function (marker, i) {
	          if (i > 0) {
	            var distance = marker.getLatLng().distanceTo(that.markers[i - 1].getLatLng());
	            that.range = +(that.range + distance).toFixed();
	          }
	        });
	      }
	    },
	    formatDistance: function formatDistance() {
	      if (this.range < 1000) {
	        return this.range + ' m';
	      } else {
	        var rangeKm = +(this.range / 1000).toFixed(2);
	        return rangeKm + ' km';
	      }
	    },
	    deleteLastMarker: function deleteLastMarker() {
	      if (this.markers.length > 0) {
	        _store2.default.state.map.removeLayer(this.markers[this.markers.length - 1]);
	        this.markers.pop();
	      }
	      if (this.polylines.length > 0) {
	        _store2.default.state.map.removeLayer(this.polylines[this.polylines.length - 1]);
	        this.polylines.pop();
	      }
	      this.distanceBetweenMarkers();
	    },
	    deleteAllMarkers: function deleteAllMarkers() {
	      this.markers.forEach(function (marker) {
	        _store2.default.state.map.removeLayer(marker);
	      });
	      this.polylines.forEach(function (polyline) {
	        _store2.default.state.map.removeLayer(polyline);
	      });
	      this.markers = [];
	      this.polylines = [];
	      this.range = 0;
	    },
	    closeRange: function closeRange() {
	      this.active = false;
	      this.expand = false;
	      this.deleteAllMarkers();
	      _store2.default.state.map.off('click');
	    },
	    expandRange: function expandRange() {
	      this.expand = !this.expand;
	    }
	  }
	};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(4);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _leafletGeosearch = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var provider = new _leafletGeosearch.OpenStreetMapProvider();
	exports.default = {
	  name: 'route',
	  data: function data() {
	    return {
	      active: false,
	      expand: false,
	      routeFound: false,
	      error: false,
	      loading: false,
	      iconUrl: cgy_vars.defaultMarker,
	      provider: provider,
	      start: '',
	      end: '',
	      startClean: '',
	      endClean: '',
	      routeSummary: '',
	      waypoints: [],
	      costingVal: 'DRIVING',
	      markers: [],
	      routing: '',
	      strokeColor: cgy_vars.line.strokeColor,
	      pointMarkerStyle: {
	        radius: 5,
	        color: cgy_vars.line.strokeColor,
	        fillColor: 'white',
	        opacity: 1,
	        fillOpacity: 0.7
	      }
	    };
	  },
	
	  methods: {
	    routeOnClick: function routeOnClick(place) {
	      this.active = true;
	      this.expand = true;
	      if (place) {
	        this.start = place.lat + ', ' + place.lng;
	      }
	    },
	    getWayPoints: function getWayPoints() {
	      if (this.start === '' || this.end === '') {
	        return;
	      }
	      this.routeFound = false;
	      this.waypoints = [];
	      this.cleanAddr = [];
	      this.removePrevRoute();
	      this.getLatLngFromAddress(this.start, false);
	      this.getLatLngFromAddress(this.end, true);
	    },
	    getLatLngFromAddress: function getLatLngFromAddress(addr, isLast) {
	      var that = this;
	      this.loading = true;
	      this.provider.search({ query: addr }).then(function (data) {
	        console.log(data);
	        if (data.length > 0 && data[0].label) {
	          that.error = false;
	          data = data[0];
	          that.cleanAddr.push(data.label);
	          that.waypoints.push(L.latLng(data.y, data.x));
	          if (isLast) {
	            that.displayRouteOnMap();
	            that.loading = false;
	          }
	        } else {
	          that.error = true;
	          that.loading = false;
	          var container = document.querySelectorAll('.routing__container')[0];
	          container.innerHTML = '';
	        }
	      }).catch(function (error) {
	        that.error = true;
	        that.loading = false;
	        var container = document.querySelectorAll('.routing__container')[0];
	        container.innerHTML = '';
	        console.log(error);
	      });
	    },
	    displayRouteOnMap: function displayRouteOnMap() {
	      var that = this;
	      var markerIcon = L.icon({
	        iconUrl: this.iconUrl,
	        iconSize: [21, 26],
	        iconAnchor: [10.5, 26]
	      });
	      this.routing = L.Routing.control({
	        plan: L.Routing.plan(this.waypoints, {
	          createMarker: function createMarker(i, wp) {
	            return L.marker(wp.latLng, { icon: markerIcon, draggable: false }).bindPopup(that.cleanAddr[i]);
	          }
	        }),
	        router: L.Routing.google({
	          travelMode: google.maps.TravelMode[this.costingVal],
	          provideRouteAlternatives: false
	        }),
	        addWaypoints: false,
	        show: false,
	        lineOptions: {
	          styles: [{ color: this.strokeColor, opacity: 1, weight: 5 }]
	        },
	        language: 'fr'
	      }).addTo(_store2.default.state.map).on('routingerror', function (error) {
	        console.log(error);
	        that.error = true;
	        that.removePrevRoute();
	      }).on('routesfound', function (result) {
	        that.displayRouteSummary(result);
	        that.createItinary(result);
	      });
	    },
	    displayRouteSummary: function displayRouteSummary(result) {
	      this.routeFound = true;
	      this.routeSummary = result.routes[0].summary;
	      this.startClean = this.cleanAddr[0];
	      this.endClean = this.cleanAddr[1];
	    },
	    createItinary: function createItinary(result) {
	      var container = document.querySelectorAll('.routing__container')[0];
	      container.innerHTML = '';
	      var table = L.DomUtil.create('table', '');
	      var steps = L.DomUtil.create('tbody', '', table);
	      container.appendChild(table);
	
	      var r = result.routes[0];
	
	      for (var i = 0; i < r.instructions.length; i++) {
	        var instr = r.instructions[i];
	        var text = instr.text;
	        var distance = this.formatDistance(instr.distance);
	        var step = this.createStep(i + 1, text, distance, steps);
	
	        this.addRowListeners(step, r.coordinates[instr.index]);
	      }
	      this.addStartAndEnd();
	
	      return container;
	    },
	    createStep: function createStep(i, text, distance, steps) {
	      var row = L.DomUtil.create('tr', '', steps);
	      var td = void 0;
	      td = L.DomUtil.create('td', '', row);
	      td.appendChild(document.createTextNode(i + '.'));
	      td = L.DomUtil.create('td', '', row);
	      td.appendChild(document.createTextNode(text));
	      td = L.DomUtil.create('td', '', row);
	      td.appendChild(document.createTextNode(distance));
	      return row;
	    },
	    addStartAndEnd: function addStartAndEnd() {
	      var steps = document.querySelectorAll('.routing__container table tbody')[0];
	      var rowS = L.DomUtil.create('tr', '', steps);
	      var rowE = L.DomUtil.create('tr', '', steps);
	      var start = L.DomUtil.create('th', '', rowS);
	      start.setAttribute('colspan', 3);
	      var startSpan = document.createElement('span');
	      startSpan.innerHTML = '<img src="' + cgy_vars.defaultMarker + '">' + this.startClean;
	      start.appendChild(startSpan);
	      steps.insertBefore(rowS, steps.firstChild);
	      var end = L.DomUtil.create('th', '', rowE);
	      end.setAttribute('colspan', 3);
	      var endSpan = document.createElement('span');
	      endSpan.innerHTML = '<img src="' + cgy_vars.defaultMarker + '">' + this.endClean;
	      end.appendChild(endSpan);
	      steps.appendChild(rowE);
	    },
	    addRowListeners: function addRowListeners(row, coordinate) {
	      L.DomEvent.addListener(row, 'mouseover', function () {
	        this._marker = L.circleMarker(coordinate, this.pointMarkerStyle).addTo(_store2.default.state.map);
	      }, this);
	      L.DomEvent.addListener(row, 'mouseout', function () {
	        if (this._marker) {
	          _store2.default.state.map.removeLayer(this._marker);
	          delete this._marker;
	        }
	      }, this);
	      L.DomEvent.addListener(row, 'click', function (e) {
	        _store2.default.state.map.panTo(coordinate);
	        L.DomEvent.stopPropagation(e);
	      }, this);
	    },
	    formatRouteDistanceAndTime: function formatRouteDistanceAndTime() {
	      if (!this.routeFound) {
	        return '';
	      }
	      var distance = this.routeSummary.totalDistance;
	      var time = this.routeSummary.totalTime;
	
	      if (time > 3600) {
	        var h = Math.floor(time / 3600);
	        var min = time % 60;
	        time = h + ' h ' + min + ' min';
	      } else if (time > 60) {
	        time = Math.round(time / 60) + ' min';
	      } else {
	        time = time + ' sec.';
	      }
	
	      distance = this.formatDistance(distance);
	
	      return distance + ' ~' + time;
	    },
	    formatDistance: function formatDistance(d) {
	      if (d > 1000) {
	        d = +(d / 1000).toFixed(1) + ' km.';
	      } else {
	        d = d.toFixed(0) + ' m.';
	      }
	      return d;
	    },
	    switchInputValues: function switchInputValues() {
	      var tmp = this.start;
	      this.start = this.end;
	      this.end = tmp;
	    },
	    removePrevRoute: function removePrevRoute() {
	      if (this.routing !== '') {
	        this.routing.remove();
	      }
	    },
	    closeRoute: function closeRoute() {
	      this.removePrevRoute();
	      this.active = false;
	      this.expand = false;
	    },
	    expandRoute: function expandRoute() {
	      this.expand = !this.expand;
	    }
	  }
	};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(4);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _jsonUrl = __webpack_require__(6);
	
	var _jsonUrl2 = _interopRequireDefault(_jsonUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'search',
	  data: function data() {
	    return {
	      keyword: '',
	      results: [],
	      open: false
	    };
	  },
	
	  methods: {
	    sendSearch: function sendSearch() {
	      this.doSearchReq(this.openSearchPanel);
	    },
	    doSearchReq: function doSearchReq(callback) {
	      var _this = this;
	
	      if (_store2.default.cache.search[this.keyword] && _store2.default.cache.activate) {
	        this.results = _store2.default.cache.search[this.keyword];
	        if (callback !== null) {
	          callback();
	        }
	      } else {
	        this.$http.get(_jsonUrl2.default.url.search + '&s=' + this.keyword).then(function (response) {
	          _this.results = response.data;
	          _this.$parent.keyword = _this.keyword;
	          _store2.default.cache.search[_this.keyword] = response.data;
	          dataLayer.push({
	            'event': 'VirtualPageview',
	            'virtualPageURL': '/?s=' + _this.keyword,
	            'virtualPageTitle': 'Recherche - ' + _this.keyword
	          });
	        }, function (response) {
	          console.log('error', response);
	        }).then(function (_) {
	          if (callback !== null) {
	            callback();
	          }
	        });
	      }
	    },
	    openSearchPanel: function openSearchPanel() {
	      this.$parent.level = 2;
	      this.$parent.levelName = 'search';
	      this.$parent.keyword = this.keyword;
	    }
	  }
	};

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(58)
	
	/* template */
	var __vue_template__ = __webpack_require__(141)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(59)
	
	/* template */
	var __vue_template__ = __webpack_require__(143)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(60)
	
	/* template */
	var __vue_template__ = __webpack_require__(137)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(61)
	
	/* template */
	var __vue_template__ = __webpack_require__(146)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(62)
	
	/* template */
	var __vue_template__ = __webpack_require__(144)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(63)
	
	/* template */
	var __vue_template__ = __webpack_require__(139)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(64)
	
	/* template */
	var __vue_template__ = __webpack_require__(140)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(65)
	
	/* template */
	var __vue_template__ = __webpack_require__(142)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(66)
	
	/* template */
	var __vue_template__ = __webpack_require__(138)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(67)
	
	/* template */
	var __vue_template__ = __webpack_require__(145)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "map__wrapper"
	  }, [(_vm.mapHeader) ? _c('div', {
	    staticClass: "map__header"
	  }, [_c('div', {
	    staticClass: "wrapper"
	  }, [_c('span', {
	    staticClass: "header__title"
	  }, [_vm._v(_vm._s(_vm.headerTitle))]), _vm._v(" "), _c('span', {
	    staticClass: "header__description",
	    domProps: {
	      "innerHTML": _vm._s(_vm.headerDescription)
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "map"
	    }
	  }), _vm._v(" "), (_vm.mapLegend) ? _c('div', {
	    staticClass: "map__legend"
	  }, [_c('div', {
	    staticClass: "wrapper"
	  }, [_c('span', {
	    staticClass: "legend-label"
	  }, [_vm._v("Légende :")]), _vm._v(" "), _c('ul', {
	    staticClass: "legend-list"
	  }, _vm._l((_vm.legends), function(legend) {
	    return _c('li', {
	      staticClass: "legend-list-item"
	    }, [_c('img', {
	      staticClass: "attachment-80x60",
	      attrs: {
	        "width": "32",
	        "height": "37",
	        "src": legend.icon,
	        "title": legend.name,
	        "alt": ("Icône " + (legend.name))
	      }
	    }), _vm._v(" "), _c('span', {
	      staticClass: "legend-list-text"
	    }, [_vm._v(_vm._s(legend.name))])])
	  }), 0)])]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn-map",
	    on: {
	      "click": _vm.proximityClick
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-map",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-map"
	    }
	  })]), _vm._v("\n    A proximité\n  ")])])
	},staticRenderFns: []}

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "slideUp"
	    }
	  }, [(_vm.active) ? _c('div', {
	    attrs: {
	      "id": "route"
	    }
	  }, [_c('div', {
	    staticClass: "route__header"
	  }, [_c('div', {
	    staticClass: "route__header-content"
	  }, [_c('div', {
	    staticClass: "header__title"
	  }, [_c('svg', {
	    staticClass: "icon icon-compass",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-compass"
	    }
	  })]), _vm._v("\n          Itinéraire\n        ")]), _vm._v(" "), _c('span', {
	    staticClass: "distance"
	  }, [_vm._v(_vm._s(_vm.formatRouteDistanceAndTime()))])]), _vm._v(" "), _c('ul', {
	    staticClass: "group-buttons"
	  }, [_c('li', [_c('button', {
	    on: {
	      "click": _vm.expandRoute
	    }
	  }, [(_vm.expand) ? _c('svg', {
	    staticClass: "icon icon-reduce",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-reduce"
	    }
	  })]) : _c('svg', {
	    staticClass: "icon icon-expand",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-expand"
	    }
	  })])])]), _vm._v(" "), _c('li', [_c('button', {
	    on: {
	      "click": _vm.closeRoute
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-close",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-close"
	    }
	  })])])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.expand),
	      expression: "expand"
	    }],
	    staticClass: "route__content"
	  }, [(_vm.loading) ? _c('span', {
	    staticClass: "loader"
	  }) : _vm._e(), _vm._v(" "), _c('form', {
	    attrs: {
	      "action": "#"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.getWayPoints($event)
	      }
	    }
	  }, [(_vm.error) ? _c('span', {
	    staticClass: "error"
	  }, [_vm._v("Un problème est survenu")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form__row"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.start),
	      expression: "start"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Départ",
	      "tabindex": "1",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.start)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.start = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.switchInputValues($event)
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-inverse",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-inverse"
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form__row"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.end),
	      expression: "end"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Arrivée",
	      "tabindex": "2",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.end)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.end = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    attrs: {
	      "type": "submit",
	      "tabindex": "5"
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-search",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-search"
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form__row"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.costingVal),
	      expression: "costingVal"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "type",
	      "id": "drive",
	      "value": "DRIVING"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.costingVal, "DRIVING")
	    },
	    on: {
	      "change": function($event) {
	        _vm.costingVal = "DRIVING"
	      }
	    }
	  }), _c('label', {
	    attrs: {
	      "for": "drive",
	      "tabindex": "3"
	    }
	  }, [_vm._v("En voiture")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.costingVal),
	      expression: "costingVal"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "type",
	      "id": "walk",
	      "value": "WALKING"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.costingVal, "WALKING")
	    },
	    on: {
	      "change": function($event) {
	        _vm.costingVal = "WALKING"
	      }
	    }
	  }), _c('label', {
	    attrs: {
	      "for": "walk",
	      "tabindex": "4"
	    }
	  }, [_vm._v("A pied")])])]), _vm._v(" "), _c('div', {
	    staticClass: "routing__container"
	  })])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "slideUp"
	    }
	  }, [(_vm.active) ? _c('div', {
	    attrs: {
	      "id": "place-info"
	    }
	  }, [_c('div', {
	    staticClass: "place__header"
	  }, [_c('div', {
	    staticClass: "place__header-content"
	  }, [_c('h1', {
	    staticClass: "header__title"
	  }, [(_vm.place.icon) ? _c('img', {
	    attrs: {
	      "src": _vm.place.icon,
	      "alt": ""
	    }
	  }) : _c('img', {
	    attrs: {
	      "src": _vm.iconUrl,
	      "alt": ""
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.place.name) + "\n        ")])]), _vm._v(" "), _c('ul', {
	    staticClass: "group-buttons"
	  }, [_c('li', [_c('button', {
	    on: {
	      "click": _vm.expandPlaceInfo
	    }
	  }, [(_vm.expand) ? _c('svg', {
	    staticClass: "icon icon-reduce",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-reduce"
	    }
	  })]) : _c('svg', {
	    staticClass: "icon icon-expand",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-expand"
	    }
	  })])])]), _vm._v(" "), _c('li', [_c('button', {
	    on: {
	      "click": _vm.closePlaceInfo
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-close",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-close"
	    }
	  })])])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.expand),
	      expression: "expand"
	    }],
	    staticClass: "place__content"
	  }, [_c('div', {
	    staticClass: "place__description",
	    domProps: {
	      "innerHTML": _vm._s(_vm.place.content)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "place__tools"
	  }, [_c('div', {
	    staticClass: "section"
	  }, [_c('div', {
	    staticClass: "section__title"
	  }, [_c('span', [_vm._v("Outils")])]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.proximityClick
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-map",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-map"
	    }
	  })]), _vm._v("\n            A proximité\n          ")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.routeClick
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-compass",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-compass"
	    }
	  })]), _vm._v("\n            Itinéraire\n          ")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.contactClick
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-bubble",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-bubble"
	    }
	  })]), _vm._v("\n            Remarques\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "place__footer",
	    domProps: {
	      "innerHTML": _vm._s(_vm.place.footer)
	    }
	  })])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "slideUp"
	    }
	  }, [(_vm.active) ? _c('div', {
	    attrs: {
	      "id": "proximity"
	    }
	  }, [_c('div', {
	    staticClass: "proximity__header"
	  }, [_c('div', {
	    staticClass: "proximity__header-content"
	  }, [_c('div', {
	    staticClass: "header__title"
	  }, [_c('svg', {
	    staticClass: "icon icon-map",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-map"
	    }
	  })]), _vm._v("\n          A proximité\n        ")]), _vm._v(" "), _c('span', {
	    staticClass: "distance"
	  }, [_vm._v(_vm._s(_vm.radius) + " kilomètre(s)")])]), _vm._v(" "), _c('ul', {
	    staticClass: "group-buttons"
	  }, [_c('li', [_c('button', {
	    on: {
	      "click": _vm.expandProximity
	    }
	  }, [(_vm.expand) ? _c('svg', {
	    staticClass: "icon icon-reduce",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-reduce"
	    }
	  })]) : _c('svg', {
	    staticClass: "icon icon-expand",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-expand"
	    }
	  })])])]), _vm._v(" "), _c('li', [_c('button', {
	    on: {
	      "click": _vm.closeProximity
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-close",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-close"
	    }
	  })])])])])]), _vm._v(" "), (_vm.expand) ? _c('div', {
	    staticClass: "proximity__content"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.radius),
	      expression: "radius"
	    }],
	    attrs: {
	      "type": "range",
	      "min": _vm.rangeMin,
	      "max": _vm.rangeMax,
	      "step": "0.1"
	    },
	    domProps: {
	      "value": (_vm.radius)
	    },
	    on: {
	      "change": _vm.isInRange,
	      "__r": function($event) {
	        _vm.radius = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('form', {
	    attrs: {
	      "action": "#"
	    }
	  }, [_c('p', [_vm._v("N'afficher que ces catégories (optionnel):")]), _vm._v(" "), _vm._l((_vm.categories), function(cat) {
	    return _c('div', {
	      staticClass: "form__row"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selectedCat),
	        expression: "selectedCat"
	      }],
	      attrs: {
	        "type": "checkbox",
	        "id": ((cat.id) + "-" + (cat.slug))
	      },
	      domProps: {
	        "value": cat.id,
	        "checked": true,
	        "checked": Array.isArray(_vm.selectedCat) ? _vm._i(_vm.selectedCat, cat.id) > -1 : (_vm.selectedCat)
	      },
	      on: {
	        "change": [function($event) {
	          var $$a = _vm.selectedCat,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = cat.id,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.selectedCat = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (_vm.selectedCat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.selectedCat = $$c
	          }
	        }, function($event) {
	          return _vm.getCats()
	        }]
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ((cat.id) + "-" + (cat.slug))
	      }
	    }, [_vm._v(_vm._s(cat.name))])])
	  })], 2)]) : _vm._e()]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('modal'), _vm._v(" "), _c('contact'), _vm._v(" "), _c('panel'), _vm._v(" "), _c('maps'), _vm._v(" "), _c('place-info'), _vm._v(" "), _c('proximity'), _vm._v(" "), _c('range'), _vm._v(" "), _c('route')], 1)
	},staticRenderFns: []}

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "slideUp"
	    }
	  }, [(_vm.active) ? _c('div', {
	    attrs: {
	      "id": "range"
	    }
	  }, [_c('div', {
	    staticClass: "range__header"
	  }, [_c('div', {
	    staticClass: "range__header-content"
	  }, [_c('div', {
	    staticClass: "header__title"
	  }, [_c('svg', {
	    staticClass: "icon icon-pin",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-pin"
	    }
	  })]), _vm._v("\n          Calcul de distance\n        ")]), _vm._v(" "), _c('span', {
	    staticClass: "distance"
	  }, [_vm._v(_vm._s(_vm.formatDistance()))])]), _vm._v(" "), _c('ul', {
	    staticClass: "group-buttons"
	  }, [_c('li', [_c('button', {
	    on: {
	      "click": _vm.expandRange
	    }
	  }, [(_vm.expand) ? _c('svg', {
	    staticClass: "icon icon-reduce",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-reduce"
	    }
	  })]) : _c('svg', {
	    staticClass: "icon icon-expand",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-expand"
	    }
	  })])])]), _vm._v(" "), _c('li', [_c('button', {
	    on: {
	      "click": _vm.closeRange
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-close",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-close"
	    }
	  })])])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.expand),
	      expression: "expand"
	    }],
	    staticClass: "range__content"
	  }, [_vm._v("\n      Cliquer sur la carte pour ajouter un point\n      "), _c('ul', [_c('li', [_c('button', {
	    on: {
	      "click": _vm.deleteLastMarker
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-back",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-back"
	    }
	  })]), _vm._v("\n            Retirer le dernier point\n          ")])]), _vm._v(" "), _c('li', [_c('button', {
	    on: {
	      "click": _vm.deleteAllMarkers
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-close",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-close"
	    }
	  })]), _vm._v("\n            Retirer tous les points\n          ")])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "contact"
	    }
	  }, [(_vm.modal) ? _c('div', {
	    staticClass: "modal__overlay"
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.modal) ? _c('div', {
	    staticClass: "modal modal__contact"
	  }, [_c('span', {
	    staticClass: "modal__close",
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
	    staticClass: "modal__title"
	  }, [_vm._v("Contacter le webmaster")]), _vm._v(" "), _c('form', {
	    attrs: {
	      "action": "#"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.sendMessage($event)
	      }
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("Votre adresse email")]), _c('br'), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    attrs: {
	      "id": "email",
	      "type": "email",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  }), _c('br'), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "message"
	    }
	  }, [_vm._v("Votre message")]), _c('br'), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.message),
	      expression: "message"
	    }],
	    attrs: {
	      "id": "message",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.message)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.message = $event.target.value
	      }
	    }
	  }), _c('br'), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden"
	    },
	    domProps: {
	      "value": _vm.nonce
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Les informations recueillies à partir de ce formulaire permettent au Département des Yvelines d'améliorer les informations proposées sur le site «https://plan.yvelines.fr/».\n           Elles sont transmises à la direction de la communication et le cas échéant aux services du département en charge du lieu concerné par vos remarques.\n           "), _c('a', {
	    attrs: {
	      "href": "https://plan.yvelines.fr/mentions-du-formulaire-de-remarque/"
	    }
	  }, [_vm._v("En savoir plus sur la gestion de vos données et vos droits")])]), _vm._v(" "), _c('button', {
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Envoyer")])]), _vm._v(" "), (_vm.sent) ? _c('span', {
	    staticClass: "response",
	    class: {
	      'error': _vm.error, 'success': !_vm.error
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.response) + "\n      ")]) : _vm._e()]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "panel"
	    }
	  }, [_c('div', {
	    staticClass: "panel-header"
	  }, [_c('a', {
	    staticClass: "logo-link",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": _vm.goToFirstLevel
	    }
	  }, [_c('div', {
	    staticClass: "logo-container",
	    domProps: {
	      "innerHTML": _vm._s(_vm.logo)
	    }
	  })]), _vm._v(" "), (!_vm.panel) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.openPanel
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-menu",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-menu"
	    }
	  })]), _vm._v("\n      Menu\n    ")]) : _vm._e(), _vm._v(" "), (_vm.panel) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.closePanel
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-close",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-close"
	    }
	  })])]) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "slideIn"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.panel),
	      expression: "panel"
	    }],
	    staticClass: "panel-aside panel-aside--parent"
	  }, [_c('div', {
	    staticClass: "logo-container",
	    domProps: {
	      "innerHTML": _vm._s(_vm.logo)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "site-slogan"
	  }, [_vm._v(" " + _vm._s(_vm.slogan) + " ")]), _vm._v(" "), _c('search'), _vm._v(" "), _c('ul', {
	    staticClass: "panel-aside__main-nav"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.openPanel('place')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "item__name"
	  }, [_vm._v("Lieux")]), _vm._v(" "), _c('div', {
	    staticClass: "item__next"
	  }, [_c('svg', {
	    staticClass: "icon icon-arrow-right",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-arrow-right"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "nb"
	  }, [_vm._v(_vm._s(_vm.catsNb))])])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.openPanel('map')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "item__name"
	  }, [_vm._v("Plans")]), _vm._v(" "), _c('div', {
	    staticClass: "item__next"
	  }, [_c('svg', {
	    staticClass: "icon icon-arrow-right",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-arrow-right"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "nb"
	  }, [_vm._v(_vm._s(_vm.mapsNb))])])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.openPanel('settings')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "item__name"
	  }, [_vm._v("Paramètres")]), _vm._v(" "), _c('div', {
	    staticClass: "item__next"
	  }, [_c('svg', {
	    staticClass: "icon icon-arrow-right",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-arrow-right"
	    }
	  })])])])])]), _vm._v(" "), _c('ul', {
	    staticClass: "panel-aside__footer-nav"
	  }, _vm._l((_vm.pages), function(page) {
	    return _c('li', [_c('a', {
	      attrs: {
	        "href": page.href,
	        "target": page.target
	      }
	    }, [_vm._v(" " + _vm._s(page.title) + " >")])])
	  }), 0)], 1)]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "slideIn"
	    }
	  }, [(_vm.level === 2 && _vm.levelName === 'place') ? _c('div', {
	    staticClass: "panel-aside panel-aside--child"
	  }, [_c('search'), _vm._v(" "), _c('a', {
	    staticClass: "panel-prev",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": _vm.closeChildPanel
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-arrow-left",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-arrow-left"
	    }
	  })]), _vm._v("\n        Lieux\n      ")]), _vm._v(" "), _c('ul', {
	    staticClass: "panel-aside__main-nav"
	  }, _vm._l((_vm.cats), function(cat) {
	    return _c('li', [_c('a', {
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showItems(cat.name, cat.id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "item__name"
	    }, [_vm._v(_vm._s(cat.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item__next"
	    }, [_c('svg', {
	      staticClass: "icon icon-arrow-right",
	      attrs: {
	        "aria-hidden": "true",
	        "role": "img"
	      }
	    }, [_c('use', {
	      attrs: {
	        "xmlns:xlink": "http://www.w3.org/1999/xlink",
	        "xlink:href": "#icon-arrow-right"
	      }
	    })]), _vm._v(" "), _c('span', {
	      staticClass: "nb"
	    }, [_vm._v(_vm._s(cat.count))])])])])
	  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.level >= 2 && _vm.levelName === 'map') ? _c('div', {
	    staticClass: "panel-aside panel-aside--child"
	  }, [_c('search'), _vm._v(" "), _c('a', {
	    staticClass: "panel-prev",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": _vm.closeChildPanel
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-arrow-left",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-arrow-left"
	    }
	  })]), _vm._v(" "), (_vm.level === 2) ? _c('span', [_vm._v("Plans")]) : _vm._e(), _vm._v(" "), (_vm.level > 2) ? _c('span', [_vm._v(_vm._s(_vm.parentMapName))]) : _vm._e()]), _vm._v(" "), (_vm.mapsId.length > 0) ? _c('button', {
	    staticClass: "button button-show button-map",
	    on: {
	      "click": _vm.closePanel
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-eye",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-eye"
	    }
	  })]), _vm._v(" "), (_vm.mapResultBtn) ? _c('div', [(_vm.mapsId.length === 1) ? _c('span', [_vm._v("Afficher ce plan sur la carte")]) : _c('span', [_vm._v("Afficher ces plans sur la carte")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "panel-aside__main-nav"
	  }, _vm._l((_vm.maps), function(map) {
	    return _c('li', {
	      staticClass: "item-map"
	    }, [(!map.has_children) ? _c('div', {
	      staticClass: "child__wrapper"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.mapsId),
	        expression: "mapsId"
	      }],
	      attrs: {
	        "type": "checkbox",
	        "name": "map",
	        "id": ("map-" + (map.id))
	      },
	      domProps: {
	        "value": map.id,
	        "checked": Array.isArray(_vm.mapsId) ? _vm._i(_vm.mapsId, map.id) > -1 : (_vm.mapsId)
	      },
	      on: {
	        "change": [function($event) {
	          var $$a = _vm.mapsId,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = map.id,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.mapsId = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (_vm.mapsId = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.mapsId = $$c
	          }
	        }, _vm.displayMapsElements]
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ("map-" + (map.id))
	      }
	    }, [_vm._v(_vm._s(map.name))])]) : _c('div', {
	      staticClass: "parent__wrapper"
	    }, [_c('a', {
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showMaps(map.name, map.id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "item__name"
	    }, [_vm._v(_vm._s(map.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item__next"
	    }, [_c('svg', {
	      staticClass: "icon icon-arrow-right",
	      attrs: {
	        "aria-hidden": "true",
	        "role": "img"
	      }
	    }, [_c('use', {
	      attrs: {
	        "xmlns:xlink": "http://www.w3.org/1999/xlink",
	        "xlink:href": "#icon-arrow-right"
	      }
	    })]), _vm._v(" "), _c('span', {
	      staticClass: "nb"
	    }, [_vm._v(_vm._s(map.count))])])])])])
	  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.level === 2 && _vm.levelName === 'settings') ? _c('div', {
	    staticClass: "panel-aside panel-aside--child"
	  }, [_c('search'), _vm._v(" "), _c('a', {
	    staticClass: "panel-prev",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": _vm.closeChildPanel
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-arrow-left",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-arrow-left"
	    }
	  })]), _vm._v("\n        Paramètres\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "settings__tools"
	  }, [_c('div', {
	    staticClass: "tool__title"
	  }, [_c('span', [_vm._v("Outils")])]), _vm._v(" "), _c('ul', [_c('li', [_c('button', {
	    on: {
	      "click": _vm.proximityClick
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-map",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-map"
	    }
	  })]), _vm._v("\n              A proximité\n            ")])]), _vm._v(" "), _c('li', [_c('button', {
	    on: {
	      "click": _vm.rangeClick
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-pin",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-pin"
	    }
	  })]), _vm._v("\n              Calcul de distance\n            ")])]), _vm._v(" "), _c('li', [_c('button', {
	    on: {
	      "click": _vm.routeClick
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-compass",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-compass"
	    }
	  })]), _vm._v("\n              Itinéraire\n            ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "render__tools"
	  }, [_c('div', {
	    staticClass: "tool__title"
	  }, [_c('span', [_vm._v("Rendu")])]), _vm._v(" "), _c('ul', [_c('li', [_c('button', {
	    on: {
	      "click": function($event) {
	        return _vm.changeMapRender('plan')
	      }
	    }
	  }, [_vm._v("Plan")])]), _vm._v(" "), _c('li', [_c('button', {
	    on: {
	      "click": function($event) {
	        return _vm.changeMapRender('relief')
	      }
	    }
	  }, [_vm._v("Relief")])]), _vm._v(" "), _c('li', [_c('button', {
	    on: {
	      "click": function($event) {
	        return _vm.changeMapRender('sat')
	      }
	    }
	  }, [_vm._v("Satellite")])]), _vm._v(" "), _c('li', [_c('button', {
	    on: {
	      "click": function($event) {
	        return _vm.changeMapRender('mixte')
	      }
	    }
	  }, [_vm._v("Mixte")])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.level === 2 && _vm.levelName === 'search') ? _c('div', {
	    staticClass: "panel-aside panel-aside--child"
	  }, [_c('search'), _vm._v(" "), _c('a', {
	    staticClass: "panel-prev",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": _vm.closeChildPanel
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-arrow-left",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-arrow-left"
	    }
	  })]), _vm._v("\n        " + _vm._s(_vm.keyword) + "\n      ")]), _vm._v(" "), (_vm.items.length > 0) ? _c('button', {
	    staticClass: "button button-show button-places",
	    on: {
	      "click": function($event) {
	        return _vm.displayAllMarkerOnMap(_vm.items)
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-eye",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-eye"
	    }
	  })]), _vm._v("\n        Afficher ces lieux sur la carte\n      ")]) : _vm._e(), _vm._v(" "), (_vm.items.length === 0) ? _c('span', {
	    staticClass: "error"
	  }, [_vm._v("Aucun résultat avec le mot clé " + _vm._s(_vm.keyword))]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "panel-aside__main-nav"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isLoading),
	      expression: "isLoading"
	    }],
	    staticClass: "panel-aside__loader"
	  }), _vm._v(" "), _vm._l((_vm.items), function(item) {
	    return _c('li', [(item.type === 'category') ? _c('a', {
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showItems(item.name, item.id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "item__name"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item__next"
	    }, [_c('svg', {
	      staticClass: "icon icon-arrow-right",
	      attrs: {
	        "aria-hidden": "true",
	        "role": "img"
	      }
	    }, [_c('use', {
	      attrs: {
	        "xmlns:xlink": "http://www.w3.org/1999/xlink",
	        "xlink:href": "#icon-arrow-right"
	      }
	    })]), _vm._v(" "), _c('span', {
	      staticClass: "nb"
	    }, [_vm._v(_vm._s(item.count))])])]) : _c('a', {
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.getPlaceInfo(item.id)
	        }
	      }
	    }, [(item.icon) ? _c('img', {
	      staticClass: "place-icon",
	      attrs: {
	        "src": item.icon,
	        "alt": ""
	      }
	    }) : _c('img', {
	      staticClass: "place-icon",
	      attrs: {
	        "src": _vm.iconUrl,
	        "alt": ""
	      }
	    }), _vm._v("\n            " + _vm._s(item.name) + "\n          ")])])
	  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.level >= 3 && _vm.levelName === 'place') ? _c('div', {
	    staticClass: "panel-aside panel-aside--child"
	  }, [_c('search'), _vm._v(" "), _c('a', {
	    staticClass: "panel-prev",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": _vm.closeChildPanel
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-arrow-left",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-arrow-left"
	    }
	  })]), _vm._v("\n        " + _vm._s(_vm.parentName) + "\n      ")]), _vm._v(" "), (_vm.resultBtn) ? _c('div', {
	    staticClass: "button__wrapper"
	  }, [_c('button', {
	    staticClass: "button button-show hide-xs",
	    on: {
	      "click": function($event) {
	        return _vm.displayAllMarkerOnMap(_vm.items)
	      }
	    }
	  }, [_c('svg', {
	    staticClass: "icon icon-eye",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-eye"
	    }
	  })]), _vm._v("\n          Afficher ces lieux sur la carte\n        ")])]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "panel-aside__main-nav"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isLoading),
	      expression: "isLoading"
	    }],
	    staticClass: "panel-aside__loader"
	  }), _vm._v(" "), _vm._l((_vm.items), function(item) {
	    return _c('li', [(item.type === 'category') ? _c('a', {
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showItems(item.name, item.id)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "item__name"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item__next"
	    }, [_c('svg', {
	      staticClass: "icon icon-arrow-right",
	      attrs: {
	        "aria-hidden": "true",
	        "role": "img"
	      }
	    }, [_c('use', {
	      attrs: {
	        "xmlns:xlink": "http://www.w3.org/1999/xlink",
	        "xlink:href": "#icon-arrow-right"
	      }
	    })]), _vm._v(" "), _c('span', {
	      staticClass: "nb"
	    }, [_vm._v(_vm._s(item.count))])])]) : _c('a', {
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.getPlaceInfo(item.id)
	        }
	      }
	    }, [(item.icon) ? _c('img', {
	      staticClass: "place-icon",
	      attrs: {
	        "src": item.icon,
	        "alt": ""
	      }
	    }) : _c('img', {
	      staticClass: "place-icon",
	      attrs: {
	        "src": _vm.iconUrl,
	        "alt": ""
	      }
	    }), _vm._v("\n            " + _vm._s(item.name) + "\n          ")])])
	  })], 2)], 1) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "search"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.keyword),
	      expression: "keyword"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Rechercher un lieu"
	    },
	    domProps: {
	      "value": (_vm.keyword)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.sendSearch($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.keyword = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('svg', {
	    staticClass: "icon icon-search",
	    attrs: {
	      "aria-hidden": "true",
	      "role": "img"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "xlink:href": "#icon-search"
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.modalCookie && _vm.display) ? _c('div', {
	    attrs: {
	      "id": "modal"
	    }
	  }, [(_vm.modal) ? _c('div', {
	    staticClass: "modal__overlay"
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.modal) ? _c('div', {
	    staticClass: "modal modal__welcome"
	  }, [_c('span', {
	    staticClass: "modal__title"
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
	    staticClass: "modal__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.text)
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v(_vm._s(_vm.button))])]) : _vm._e()])], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.js